import { useTranslation } from 'react-i18next';

import {
  RecipientType,
  Trigger,
  TriggerActionType,
} from 'models/automation/Triggers';
import { Row } from '@tanstack/react-table';

interface RecipientsCellProps {
  getValue: () => Trigger['recipients'];
  row: Row<Trigger>;
}

const RecipientsCell = ({ getValue, row }: RecipientsCellProps) => {
  const { t } = useTranslation();
  const value = getValue();

  if (!value) {
    return '';
  }

  if (row?.original?.actionType === TriggerActionType.DIRECT_MESSAGE) {
    return t('pageAutomations.triggers.recipientType', {
      context: RecipientType.GUEST,
    });
  }

  if (value.length === 1) {
    const [{ type }] = value;

    return t('pageAutomations.triggers.recipientType', { context: type });
  }

  return t('common.multiple');
};

export default RecipientsCell;
